<!--  -->
<div class="loader" *ngIf="isSpinnerVisible || commonStore.loaderState">
<mat-spinner ></mat-spinner>
</div>